interface IconProps {
  className?: string;
}

const RemoveStyleIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.14454 5C9.14454 4.44772 9.59226 4 10.1445 4H20.1445C20.6968 4 21.1445 4.44772 21.1445 5V7C21.1445 7.55228 20.6968 8 20.1445 8C19.5923 8 19.1445 7.55228 19.1445 7V6H14.0273L13.7618 8.12403C13.6933 8.67206 13.1935 9.06078 12.6455 8.99228C12.0975 8.92378 11.7088 8.42399 11.7773 7.87597L12.0118 6H10.1445C9.59226 6 9.14454 5.55228 9.14454 5ZM4.40125 4.83104C4.7707 4.42053 5.40299 4.38725 5.8135 4.75671L20.8135 18.2567C21.224 18.6262 21.2573 19.2585 20.8878 19.669C20.5184 20.0795 19.8861 20.1128 19.4756 19.7433L12.9217 13.8448L12.1368 20.124C12.0683 20.6721 11.5685 21.0608 11.0205 20.9923C10.4725 20.9238 10.0838 20.424 10.1523 19.876L11.11 12.2143L4.47558 6.24329C4.06507 5.87384 4.03179 5.24155 4.40125 4.83104Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RemoveStyleIcon;
